"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getYearsPeriod = exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _lodash = _interopRequireDefault(require("lodash"));
require("react-datepicker/dist/react-datepicker.css");
require("react-datepicker/src/stylesheets/datepicker.scss");
var _timePickerMenu = _interopRequireDefault(require("../timePickerMenu"));
var _constants = require("../constants");
var _buttonV = _interopRequireDefault(require("../../buttonV2"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var VIEW_MODE = {
  DAY: 'day',
  MONTH: 'month',
  YEAR: 'year'
};
var DEFAULT_YEAR_ITEM_NUMBER = 12;
var getYear = function getYear(date) {
  var year = (0, _momentTimezone.default)(date).format(_constants.DATE_TIME_FORMAT.longYear);
  return Number(year);
};
var getYearsPeriod = function getYearsPeriod(date) {
  var yearItemNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_YEAR_ITEM_NUMBER;
  var endPeriod = Math.ceil(getYear(date) / yearItemNumber) * yearItemNumber;
  var startPeriod = endPeriod - (yearItemNumber - 1);
  return {
    startPeriod: startPeriod,
    endPeriod: endPeriod
  };
};
exports.getYearsPeriod = getYearsPeriod;
var iconBaseStyles = {
  color: function color(theme) {
    return theme.palette.primary.main;
  },
  p: 0,
  height: 25,
  '.chevron-icon': {
    fontSize: 9
  },
  '&:hover': {
    background: 'none'
  }
};
var DateTimePicker = function DateTimePicker(props) {
  var className = props.className,
    value = props.value,
    onChange = props.onChange,
    minDate = props.minDate,
    maxDate = props.maxDate,
    dateFormat = props.dateFormat,
    dateTimeFormat = props.dateTimeFormat,
    datePickerFormat = props.datePickerFormat,
    dateTimePickerFormat = props.dateTimePickerFormat,
    renderInput = props.renderInput,
    disabled = props.disabled,
    isShowTime = props.isShowTime;
  var refInputDate = (0, _react.useRef)(renderInput);
  var _useState = (0, _react.useState)(VIEW_MODE.DAY),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    viewMode = _useState2[0],
    setViewMode = _useState2[1];
  var _useState3 = (0, _react.useState)(DEFAULT_YEAR_ITEM_NUMBER),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    yearItemNumber = _useState4[0],
    setYearItemNumber = _useState4[1];
  var onValueChange = function onValueChange(newValue) {
    switch (viewMode) {
      case VIEW_MODE.MONTH:
        setViewMode(VIEW_MODE.DAY);
        break;
      case VIEW_MODE.YEAR:
        setViewMode(VIEW_MODE.MONTH);
        break;
      default:
        break;
    }
    onChange(newValue);
  };
  var onBlurChange = function onBlurChange(e) {
    onValueChange(e.target.value);
  };
  var renderTimePickerMenu = function renderTimePickerMenu() {
    return /*#__PURE__*/_react.default.createElement(_timePickerMenu.default, {
      data: (0, _momentTimezone.default)(value),
      onChangeTime: onChange
    });
  };
  var renderToggleControl = function renderToggleControl() {
    var inputProps = {
      bsRole: 'toggle',
      customValue: value,
      inputIconClass: isShowTime ? 'fa-regular fa-calendar-clock' : 'far fa-calendar-alt',
      readOnly: true,
      key: 'inputDate'
    };
    var ToggleControl = refInputDate.current;
    return /*#__PURE__*/_react.default.createElement(ToggleControl, inputProps);
  };
  var onClickOutside = function onClickOutside() {
    setViewMode(VIEW_MODE.DAY);
  };
  var onClickHeader = function onClickHeader() {
    switch (viewMode) {
      case VIEW_MODE.DAY:
        setYearItemNumber(1);
        setViewMode(VIEW_MODE.MONTH);
        break;
      case VIEW_MODE.MONTH:
        setYearItemNumber(DEFAULT_YEAR_ITEM_NUMBER);
        setViewMode(VIEW_MODE.YEAR);
        break;
      default:
        break;
    }
  };
  var onClickDecreaseOrIncrease = function onClickDecreaseOrIncrease(month, year) {
    return function () {
      switch (viewMode) {
        case VIEW_MODE.DAY:
          month();
          break;
        case VIEW_MODE.MONTH:
          year();
          break;
        case VIEW_MODE.YEAR:
          year();
          break;
        default:
          break;
      }
    };
  };
  var handleDisabledDecreaseOrIncrease = function handleDisabledDecreaseOrIncrease(month, year) {
    switch (viewMode) {
      case VIEW_MODE.DAY:
        return month;
      case VIEW_MODE.MONTH:
        return month;
      case VIEW_MODE.YEAR:
        return year;
      default:
        break;
    }
    return false;
  };
  var renderHeaderText = function renderHeaderText(date) {
    var text = '';
    switch (viewMode) {
      case VIEW_MODE.DAY:
        text = (0, _momentTimezone.default)(date).format(_constants.DATE_TIME_FORMAT.shortMonth);
        break;
      case VIEW_MODE.MONTH:
        text = (0, _momentTimezone.default)(date).format(_constants.DATE_TIME_FORMAT.longYear);
        break;
      case VIEW_MODE.YEAR:
        {
          var yearPeriod = getYearsPeriod(date, yearItemNumber);
          text = "".concat(yearPeriod.startPeriod, " - ").concat(yearPeriod.endPeriod);
          break;
        }
      default:
        break;
    }
    return text;
  };
  var _renderCustomHeader = function renderCustomHeader(_ref) {
    var date = _ref.date,
      decreaseMonth = _ref.decreaseMonth,
      increaseMonth = _ref.increaseMonth,
      decreaseYear = _ref.decreaseYear,
      increaseYear = _ref.increaseYear,
      prevMonthButtonDisabled = _ref.prevMonthButtonDisabled,
      nextMonthButtonDisabled = _ref.nextMonthButtonDisabled,
      prevYearButtonDisabled = _ref.prevYearButtonDisabled,
      nextYearButtonDisabled = _ref.nextYearButtonDisabled;
    var isDisableDecrease = handleDisabledDecreaseOrIncrease(prevMonthButtonDisabled, prevYearButtonDisabled);
    var isDisableIncrease = handleDisabledDecreaseOrIncrease(nextMonthButtonDisabled, nextYearButtonDisabled);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "header-wrapper"
    }, /*#__PURE__*/_react.default.createElement(_buttonV.default, {
      icon: /*#__PURE__*/_react.default.createElement("i", {
        className: "fa fa-chevron-left chevron-icon",
        "aria-hidden": "true"
      }),
      muiButtonProps: {
        onClick: onClickDecreaseOrIncrease(decreaseMonth, decreaseYear),
        disabled: isDisableDecrease,
        sx: _objectSpread({}, iconBaseStyles),
        className: "btn-decrease-holder ".concat(isDisableDecrease && 'btn-disabled')
      }
    }), /*#__PURE__*/_react.default.createElement(_buttonV.default, {
      muiButtonProps: {
        variant: 'text',
        className: 'btn-header-title',
        sx: {
          p: 0,
          height: 24,
          '&:hover': {
            background: 'none'
          }
        },
        onClick: onClickHeader,
        disabled: props.disableMonthYearSelection
      }
    }, renderHeaderText(date)), /*#__PURE__*/_react.default.createElement(_buttonV.default, {
      icon: /*#__PURE__*/_react.default.createElement("i", {
        className: "fa fa-chevron-right chevron-icon",
        "aria-hidden": "true"
      }),
      muiButtonProps: {
        onClick: onClickDecreaseOrIncrease(increaseMonth, increaseYear),
        disabled: isDisableIncrease,
        sx: _objectSpread({}, iconBaseStyles),
        className: "btn-increase-holder ".concat(isDisableIncrease && 'btn-disabled')
      }
    }));
  };
  var dateTimeValue = _lodash.default.get((0, _momentTimezone.default)(value, isShowTime ? dateTimeFormat : dateFormat, true), '_d');
  if (!(0, _momentTimezone.default)(value, isShowTime ? dateTimeFormat : dateFormat, true).isValid()) {
    dateTimeValue = '';
  }

  // convert min date to the first day of month or year
  var updateMinDate = function updateMinDate(date) {
    if (date) {
      var newDate = new Date(date.getTime());
      if (viewMode === VIEW_MODE.MONTH) {
        newDate.setDate(1);
      }
      if (viewMode === VIEW_MODE.YEAR) {
        newDate.setMonth(0);
        newDate.setDate(1);
      }
      return newDate;
    }
    return date;
  };

  // convert max date to the last day of month or year
  var updateMaxDate = function updateMaxDate(date) {
    if (date) {
      var newDate = new Date(date.getTime());
      if (viewMode === VIEW_MODE.MONTH) {
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        newDate.setDate(lastDay.getDate());
      }
      if (viewMode === VIEW_MODE.YEAR) {
        newDate.setMonth(11);
        newDate.setDate(31);
      }
      return newDate;
    }
    return date;
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "datetime-picker-wrapper",
    onClick: function onClick(e) {
      return e.preventDefault();
    },
    role: "presentation"
  }, /*#__PURE__*/_react.default.createElement(_reactDatepicker.default, {
    key: "datepicker",
    className: className,
    selected: dateTimeValue,
    onBlur: function onBlur(d) {
      return onBlurChange(d);
    },
    onSelect: function onSelect(d) {
      return onValueChange(d);
    },
    showTimeInput: isShowTime,
    dateFormat: isShowTime ? dateTimePickerFormat : datePickerFormat,
    customTimeInput: renderTimePickerMenu(),
    customInput: renderToggleControl(),
    onClickOutside: onClickOutside,
    shouldCloseOnSelect: true,
    minDate: updateMinDate(_lodash.default.get(minDate, '_d')),
    maxDate: updateMaxDate(_lodash.default.get(maxDate, '_d')),
    renderCustomHeader: function renderCustomHeader(_ref2) {
      var date = _ref2.date,
        decreaseMonth = _ref2.decreaseMonth,
        increaseMonth = _ref2.increaseMonth,
        decreaseYear = _ref2.decreaseYear,
        increaseYear = _ref2.increaseYear,
        prevMonthButtonDisabled = _ref2.prevMonthButtonDisabled,
        nextMonthButtonDisabled = _ref2.nextMonthButtonDisabled,
        prevYearButtonDisabled = _ref2.prevYearButtonDisabled,
        nextYearButtonDisabled = _ref2.nextYearButtonDisabled;
      return _renderCustomHeader({
        date: date,
        decreaseMonth: decreaseMonth,
        increaseMonth: increaseMonth,
        decreaseYear: decreaseYear,
        increaseYear: increaseYear,
        prevMonthButtonDisabled: prevMonthButtonDisabled,
        nextMonthButtonDisabled: nextMonthButtonDisabled,
        prevYearButtonDisabled: prevYearButtonDisabled,
        nextYearButtonDisabled: nextYearButtonDisabled
      });
    },
    showMonthYearPicker: viewMode === VIEW_MODE.MONTH,
    showFourColumnMonthYearPicker: viewMode === VIEW_MODE.MONTH,
    showYearPicker: viewMode === VIEW_MODE.YEAR,
    yearItemNumber: yearItemNumber,
    disabled: disabled
  }));
};
DateTimePicker.propTypes = {
  renderInput: _propTypes.default.func.isRequired,
  className: _propTypes.default.string,
  value: _propTypes.default.string,
  onChange: _propTypes.default.func.isRequired,
  dateFormat: _propTypes.default.string,
  dateTimeFormat: _propTypes.default.string,
  datePickerFormat: _propTypes.default.string,
  dateTimePickerFormat: _propTypes.default.string,
  minDate: _propTypes.default.instanceOf(_momentTimezone.default),
  maxDate: _propTypes.default.instanceOf(_momentTimezone.default),
  isShowTime: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  disableMonthYearSelection: _propTypes.default.bool
};
DateTimePicker.defaultProps = {
  className: '',
  value: new Date(),
  isShowTime: false,
  dateFormat: _constants.DATE_TIME_FORMAT.shortDate,
  dateTimeFormat: _constants.DATE_TIME_FORMAT.dateTimeAMPM,
  datePickerFormat: _constants.DATE_TIME_FORMAT.shortDate,
  dateTimePickerFormat: _constants.DATE_TIME_FORMAT.dateTimeAMPM,
  minDate: null,
  maxDate: null,
  disabled: false,
  disableMonthYearSelection: false
};
var _default = DateTimePicker;
exports.default = _default;